(function () {
    function sendKlaviyoEvent(eventName, data, profileProperties = {}) {
        if (!window.theme.customerEmail)
            return; // Send Klaviyo event, only makes sense if a customer is logged in
        // If profile properties with value null or undefined exist, they will be deleted from the profile in Klaviyo
        const unsetProperties = [];
        Object.entries(profileProperties).forEach(([key, value]) => {
            if (value === null || value === undefined) {
                delete profileProperties[key];
                unsetProperties.push(key);
            }
        });
        const bodyData = {
            type: 'event',
            attributes: {
                properties: data || {},
                metric: {
                    data: {
                        type: 'metric',
                        attributes: {
                            name: eventName
                        }
                    }
                },
                profile: {
                    data: {
                        type: 'profile',
                        attributes: {
                            email: window.theme.customerEmail,
                            properties: profileProperties,
                            meta: {
                                patch_properties: {
                                    unset: unsetProperties
                                }
                            }
                        }
                    }
                }
            }
        };
        if (window.theme.customerFirstName)
            bodyData.attributes.profile.data.attributes.first_name = window.theme.customerFirstName;
        if (window.theme.customerLastName)
            bodyData.attributes.profile.data.attributes.last_name = window.theme.customerLastName;
        if (!data) {
            fetch(`https://a.klaviyo.com/client/profiles/?company_id=${window.theme.tracking.klaviyoKey}`, {
                method: 'POST',
                headers: { revision: '2024-02-15', Accept: 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    data: bodyData.attributes.profile.data
                }),
                keepalive: true
            }).then(response => {
                if (!response.ok) {
                    console.error('Updating Klaviyo profile properties failed', response);
                }
            }).catch(err => {
                console.error('Error updating Klaviyo profile properties', err);
            });
        }
        else {
            fetch(`https://a.klaviyo.com/client/events/?company_id=${window.theme.tracking.klaviyoKey}`, {
                method: 'POST',
                headers: { revision: '2024-02-15', Accept: 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    data: bodyData
                }),
                keepalive: true
            }).then(response => {
                if (!response.ok) {
                    console.error('Sending Klaviyo event failed', response);
                }
            }).catch(err => {
                console.error('Error sending Klaviyo event', err);
            });
        }
    }
    function displayCoachingProgress(container) {
        const jsonElement = container.querySelector('[data-json="coaching"]');
        if (!jsonElement)
            return;
        const data = JSON.parse(jsonElement.innerText);
        // Sort lessons by the correct order in the coaching
        const categoryArray = data.categories ? [...data.categories] : [], lessonsPerCategory = new Map(), lessonMap = new Map();
        // Calculate the lessons per category
        categoryArray.push('other');
        for (let i = 0; i < categoryArray.length; i++) {
            lessonsPerCategory.set(categoryArray[i], 0);
            lessonMap.set(categoryArray[i], []);
        }
        for (const [, lesson] of Object.entries(data.lessons)) {
            const category = lesson.tags.length > 0 ? lesson.tags[0] : 'other';
            lessonsPerCategory.set(category, lessonsPerCategory.get(category) + 1);
            lessonMap.get(category).push(lesson);
        }
        // Reorder the lessons to be sorted by category
        const sortedLessons = {};
        let lessonCounter = 0;
        for (const category of categoryArray) {
            for (const lesson of lessonMap.get(category)) {
                sortedLessons[`${lessonCounter}`] = lesson;
                lessonCounter++;
            }
        }
        data.lessons = sortedLessons;
        if (data.pageType === 'lesson') {
            const completed = (data.progress && data.progress[data.coachingType] && data.progress[data.coachingType][data.lesson.id] && data.progress[data.coachingType][data.lesson.id].completed), checkButtons = document.querySelectorAll('[data-action="check"]'), saveProgress = function (e) {
                const target = e.target;
                const button = target.getAttribute('data-action') === 'check' ? target : target.closest('[data-action="check"]');
                button.classList.add('loading');
                const completedTimestamp = Math.floor(Date.now() / 1000);
                data.progress = data.progress || {};
                data.progress[data.coachingType] = data.progress[data.coachingType] || {};
                data.progress[data.coachingType][data.lesson.id] = data.progress[data.coachingType][data.lesson.id] || {};
                if (data.progress[data.coachingType][data.lesson.id].completed) {
                    data.progress[data.coachingType][data.lesson.id].completed = false;
                }
                else {
                    data.progress[data.coachingType][data.lesson.id].completed = true;
                    data.progress[data.coachingType][data.lesson.id].completedTimestamp = completedTimestamp;
                }
                const callback = (success) => {
                    button.classList.remove('loading');
                    checkButtons.forEach((button) => {
                        if (success) {
                            button.setAttribute('data-completed', `${data.progress[data.coachingType][data.lesson.id].completed}`);
                        }
                        else {
                            data.progress[data.coachingType][data.lesson.id].completed = !data.progress[data.coachingType][data.lesson.id].completed;
                        }
                    });
                    if (success) {
                        const sidebarMenu = document.querySelector('#sidebar-menu');
                        if (sidebarMenu.hasAttribute('data-ajax-initialized')) {
                            const sidebarJson = sidebarMenu.querySelector('[data-json="coaching"]');
                            const sidebarData = JSON.parse(sidebarJson.innerText);
                            sidebarData.progress = data.progress;
                            sidebarJson.innerText = JSON.stringify(sidebarData);
                            displayCoachingProgress(sidebarMenu);
                        }
                    }
                };
                window.cmq = window.cmq || [];
                window.cmq.push({ path: 'coaching/progress', id: data.customer, value: data.progress, callback: callback });
                document.dispatchEvent(new CustomEvent('customer:metafield:save'));
                // Coaching progress tracking
                const coachingProgressEvent = {
                    coaching_name: data.meta.coachingTitle,
                    category_name: data.meta.categoryTitle,
                    lesson_name: data.meta.lessonTitle,
                    completed_timestamp: data.progress[data.coachingType][data.lesson.id].completed ? data.progress[data.coachingType][data.lesson.id].completedTimestamp : null,
                    first_previous_uncompleted_lesson_title: null,
                    first_previous_uncompleted_lesson_url: null,
                    next_uncompleted_lesson_title: null,
                    next_uncompleted_lesson_url: null,
                    lesson_no: null,
                    coaching_completed_lessons: 0,
                    category_completed_lessons: 0,
                    coaching_total_lessons: 0,
                    category_total_lessons: 0
                };
                let found = false;
                Object.entries(data.lessons).forEach(([index, lesson]) => {
                    if (lesson.id === data.lesson.id) {
                        coachingProgressEvent.lesson_no = parseInt(index) + 1;
                        found = true;
                    }
                    else if (!found && !coachingProgressEvent.first_previous_uncompleted_lesson_title && (!data.progress[data.coachingType][lesson.id] || !data.progress[data.coachingType][lesson.id].completed)) {
                        coachingProgressEvent.first_previous_uncompleted_lesson_title = lesson.title;
                        coachingProgressEvent.first_previous_uncompleted_lesson_url = lesson.url;
                    }
                    else if (found && !coachingProgressEvent.next_uncompleted_lesson_title && (!data.progress[data.coachingType][lesson.id] || !data.progress[data.coachingType][lesson.id].completed)) {
                        coachingProgressEvent.next_uncompleted_lesson_title = lesson.title;
                        coachingProgressEvent.next_uncompleted_lesson_url = lesson.url;
                    }
                    if (data.meta.categoryTitle === lesson.tags[0]) {
                        coachingProgressEvent.category_total_lessons++;
                        if (data.progress[data.coachingType][lesson.id] && data.progress[data.coachingType][lesson.id].completed)
                            coachingProgressEvent.category_completed_lessons++;
                    }
                    coachingProgressEvent.coaching_total_lessons++;
                    if (data.progress[data.coachingType][lesson.id] && data.progress[data.coachingType][lesson.id].completed)
                        coachingProgressEvent.coaching_completed_lessons++;
                });
                const profileProperties = {}, prefix = data.meta.coachingHandle;
                if (data.progress[data.coachingType][data.lesson.id].completed) {
                    profileProperties[`${prefix}_last_completed_lesson_name`] = coachingProgressEvent.lesson_name;
                    profileProperties[`${prefix}_last_completed_lesson_timestamp`] = coachingProgressEvent.completed_timestamp;
                    profileProperties[`${prefix}_last_completed_lesson_category`] = coachingProgressEvent.category_name;
                    profileProperties[`${prefix}_last_completed_lesson_no`] = coachingProgressEvent.lesson_no;
                    profileProperties[`${prefix}_first_previous_uncompleted_lesson_title`] = coachingProgressEvent.first_previous_uncompleted_lesson_title;
                    profileProperties[`${prefix}_first_previous_uncompleted_lesson_url`] = coachingProgressEvent.first_previous_uncompleted_lesson_url;
                    profileProperties[`${prefix}_next_uncompleted_lesson_title`] = coachingProgressEvent.next_uncompleted_lesson_title;
                    profileProperties[`${prefix}_next_uncompleted_lesson_url`] = coachingProgressEvent.next_uncompleted_lesson_url;
                }
                profileProperties[`${prefix}_total_lessons`] = coachingProgressEvent.coaching_total_lessons;
                profileProperties[`${prefix}_total_completed_lessons`] = coachingProgressEvent.coaching_completed_lessons;
                sendKlaviyoEvent('Coaching Progress', data.progress[data.coachingType][data.lesson.id].completed ? coachingProgressEvent : null, profileProperties);
            };
            checkButtons.forEach((button) => {
                if (completed)
                    button.setAttribute('data-completed', "true");
                button.style.display = '';
                button.addEventListener('click', saveProgress);
            });
            // Save progress when video was watched to the end
            if (data.wistiaId) {
                const player = document.querySelector(`wistia-player[media-id="${data.wistiaId}"]`);
                const onSecondChange = (e) => {
                    if (e.detail.second / player.duration * 100 < data.videoThreshold)
                        return;
                    player.removeEventListener('second-change', onSecondChange);
                    const completed = (data.progress && data.progress[data.coachingType] && data.progress[data.coachingType][data.lesson.id] && data.progress[data.coachingType][data.lesson.id].completed);
                    if (!completed)
                        checkButtons[0].click();
                };
                player.addEventListener('second-change', onSecondChange);
            }
            return;
        }
        const progressElement = container.querySelector('.CoachingProgress'), totalLessons = Object.keys(data.lessons).length;
        const categoryMarkHtml = '<div class="CoachingProgress__CategoryMark" style="left: calc({{pos}}% - var(--cat-mark-width) / 2);"></div>';
        const barElement = progressElement.querySelector('.CoachingProgress__Bar'), innerBarElement = barElement.querySelector('.CoachingProgress__BarInner[data-bar="primary"]'), secondaryBarElement = barElement.querySelector('.CoachingProgress__BarInner[data-bar="secondary"]'), numbersElement = progressElement.querySelector('.CoachingProgress__BarInfoLabelNumbers'), percentageElement = progressElement.querySelector('.CoachingProgress__BarInfoLabelPercentage'), proceedButton = progressElement.querySelector('[data-action="proceed"]'), mainProceedButton = document.querySelector('.MainBlogCoaching__Content [data-action="proceed"]');
        // Display marks for every lesson that is not the last of a category
        let consecutiveLessons = 0, currentIndex = 0, lastCompletedLesson = 0, completedLessons = 0, interrupted = false;
        for (const [, lesson] of Object.entries(data.lessons)) {
            const completed = (data.progress && data.progress[data.coachingType] && data.progress[data.coachingType][lesson.id] && data.progress[data.coachingType][lesson.id].completed);
            if (!interrupted && completed) {
                consecutiveLessons++;
            }
            else if (!interrupted) {
                interrupted = true;
                if (proceedButton)
                    proceedButton.href = `${data.coachingPath}/${lesson.handle}`; // Set next lesson as href in proceed button
                if (mainProceedButton) {
                    mainProceedButton.querySelector('[data-coaching-button-text="next-lesson-number"]').innerHTML = `${currentIndex + 1}`;
                    mainProceedButton.href = `${data.coachingPath}/${lesson.handle}`;
                }
            }
            if (completed) {
                completedLessons++;
                lastCompletedLesson = currentIndex + 1;
                const lessonElement = document.querySelector(`[data-lesson-id="${lesson.id}"`);
                if (lessonElement)
                    lessonElement.querySelector('.CoachingLessonItem__CheckButton').style.display = "block";
            }
            currentIndex++;
        }
        if (mainProceedButton && completedLessons > 0) {
            mainProceedButton.querySelector('[data-coaching-button-text="start"]').classList.add('none');
            mainProceedButton.querySelector('[data-coaching-button-text="resume"]').classList.remove('none');
        }
        // If all lessons are completed, hide the proceed button
        if (data.pageType === 'main' && completedLessons === totalLessons) {
            if (proceedButton)
                proceedButton.classList.add('none');
            if (mainProceedButton)
                mainProceedButton.classList.add('none');
        }
        // Display the title
        progressElement.querySelector(`.CoachingProgress__Header [data-title="${data.pageType}"]`).style.display = 'block';
        // Set the width of the progress bar
        innerBarElement.style.width = `${consecutiveLessons / totalLessons * 100}%`;
        secondaryBarElement.style.width = `${lastCompletedLesson / totalLessons * 100}%`;
        // Set the number of completed lessons
        numbersElement.innerText = `${completedLessons} von ${totalLessons}`;
        percentageElement.innerText = `${Math.round(completedLessons / totalLessons * 100)}`;
        // Display marks and labels for every category
        let previousWidth = 0;
        if (data.pageType === 'main') {
            for (let i = 0; i < data.categories.length; i++) {
                if (i + 1 === data.categories.length && lessonsPerCategory.get('other') === 0)
                    break;
                const category = data.categories[i];
                const categoryWidth = lessonsPerCategory.get(category) / totalLessons * 100;
                const tempMark = document.createElement('DIV');
                previousWidth += categoryWidth;
                tempMark.innerHTML = categoryMarkHtml.replace('{{pos}}', `${previousWidth}`);
                barElement.appendChild(tempMark.firstChild);
                lessonsPerCategory.get(data.categories[i]);
            }
        }
    }
    displayCoachingProgress(document.querySelector('.PageContainer'));
    document.addEventListener('theme:sidebarMenu:htmlLoaded', () => {
        displayCoachingProgress(document.querySelector('#sidebar-menu'));
    }, { once: true });
})();
/**
 * Video chapters
 */
(function () {
    const videoPlayer = document.querySelector('.CoachingLesson wistia-player');
    if (!videoPlayer)
        return;
    const formatTime = (time) => {
        const seconds = Math.floor(time % 60), minutes = Math.floor(time / 60 % 60);
        return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };
    const onApiReady = () => {
        videoPlayer.getPlugin('chapters').then(chaptersPlugin => {
            // Wrap code in try/catch to prevent breaking the JS when the API changes
            try {
                if (!chaptersPlugin.options.on)
                    return;
                const chapters = chaptersPlugin.options.chapterList;
                const chaptersContainer = document.querySelector('[data-chapters-element="container"]');
                if (!chapters || !chapters.length || !chaptersContainer)
                    return;
                const chaptersList = chaptersContainer.querySelector('[data-chapters-element="list"]');
                const chaptersTemplate = chaptersContainer.querySelector('[data-chapters-element="template"]');
                let chaptersHTML = '';
                for (let i = 0; i < chapters.length; i++) {
                    const chapter = chapters[i];
                    if (chapter.deleted)
                        continue;
                    const chapterHTML = chaptersTemplate.innerHTML.replace(/%timestring%/, formatTime(chapter.time)).replace(/%time%/, chapter.time).replace(/%title%/, chapter.title);
                    chaptersHTML += chapterHTML;
                }
                chaptersList.innerHTML = chaptersHTML;
                chaptersList.querySelectorAll('[data-chapters-element="button"]').forEach(button => {
                    button.addEventListener('click', () => {
                        videoPlayer.currentTime = parseInt(button.getAttribute('data-chapters-time'));
                    });
                });
                chaptersContainer.classList.remove('none');
            }
            catch (e) {
                console.error('Error initializing chapters', e);
            }
        }).catch(() => { });
    };
    videoPlayer.addEventListener('api-ready', () => {
        onApiReady();
    });
})();
export {};
